import { Button, Flex, FlexProps } from '@chakra-ui/react';

export interface IStaticPageFilterProps<T extends string[]> extends FlexProps {
  options: T;
  includeAll?: boolean;
  currentOption: T[number];
  onOptionChange: (options: T[number]) => void;
}

export const StaticPageFilter = <T extends string[]>({
  options,
  includeAll = false,
  currentOption,
  onOptionChange,
  ...props
}: IStaticPageFilterProps<T>) => {
  return (
    <Flex
      justifyContent={{ base: 'center', sm: 'flex-end' }}
      flexWrap="wrap"
      gap={{ base: 2, sm: 0 }}
      {...props}
    >
      {includeAll && (
        <Button
          onClick={() => onOptionChange('All')}
          variant={currentOption === 'All' ? 'static-solid' : 'static-outline'}
        >
          All
        </Button>
      )}
      {options.map((option) => (
        <Button
          key={option}
          onClick={() => onOptionChange(option)}
          variant={option === currentOption ? 'static-solid' : 'static-outline'}
          ml={{ base: 0, sm: 2 }}
        >
          {option}
        </Button>
      ))}
    </Flex>
  );
};
